import { Outlet, useNavigate } from 'react-router-dom'
import { AdminSidebar } from './AdminSidebar'
import { useAdminStore } from '../store/adminStore'
import { adminSupabase } from '../lib/adminClient'
import { IdleLogout } from '../../components/auth/IdleLogout'

export function AdminLayout() {
  const { admin, isAuthenticated } = useAdminStore()
  const navigate = useNavigate()

  return (
    <div className="flex min-h-screen bg-gray-50">
      <AdminSidebar />
      <main className="flex-1 flex flex-col min-w-0">
        {/* Impersonation banner slot — see TenantDetailPage */}
        {admin && (
          <div className="flex-1 overflow-auto">
            <Outlet />
          </div>
        )}
      </main>
      {/* Same inactivity auto-logout as the tenant app, wired to the admin session +
          the /admin/login screen, with its own cross-tab key. */}
      <IdleLogout
        isAuthenticated={isAuthenticated}
        storageKey="palstro:admin-last-activity"
        onLogout={async () => {
          try {
            await adminSupabase.auth.signOut()
          } catch {
            // clear locally regardless
          }
          useAdminStore.getState().logout()
          navigate('/admin/login', { replace: true })
        }}
      />
    </div>
  )
}
